import { render, staticRenderFns } from "./modalKemasanUpload.vue?vue&type=template&id=1b516dc5&"
import script from "./modalKemasanUpload.vue?vue&type=script&lang=js&"
export * from "./modalKemasanUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports